import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchPendingApplication } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const pendingApplicationSlice = createAsyncThunk('get/pendingApplicationSlice', FetchPendingApplication);

export const PendingApplicationSlice = createSlice({
	name: 'pendingApplicationSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[pendingApplicationSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[pendingApplicationSlice.rejected.toString()]: setAPIError,
		[pendingApplicationSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[PendingApplicationSlice.name]: ReturnType<typeof PendingApplicationSlice.reducer>;
}

export const pendingApplicationSelector = (state: IStates): any => {
	return state[PendingApplicationSlice.name] || {};
};

export const usePendingApplication = (): any => useSelector(pendingApplicationSelector);

export const getPendingApplication =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(pendingApplicationSlice(params));
		return;
	};

export const resetPendingApplication =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(PendingApplicationSlice.actions.RESET());
		return;
	};
